export default __webpack_public_path__ + "static/media/king-circle.dd1ae222.png";